export default function FlowDesigner(options: any = {}) {
  this.smallGridCellSize = options.smallGridCellSize;
  this.gridCellSize = options.gridCellSize;
}
